import { createContext, type Dispatch, type FC, type ReactNode, type SetStateAction, useState } from "react";

import { PersonVacationBalanceJSON } from "@hr/api/model";
import { EditedCellKey } from "@hr/statisticsview/vacancy/ManualTab/ManualTab.types";

type Props = {
  selectedRows: PersonVacationBalanceJSON[];
  setSelectedRows: Dispatch<SetStateAction<PersonVacationBalanceJSON[]>>;
  vacationBalances: PersonVacationBalanceJSON[];
  setVacationBalances: Dispatch<SetStateAction<PersonVacationBalanceJSON[]>>;
  editedCellKeys: Set<EditedCellKey>;
  setEditedCellKeys: Dispatch<SetStateAction<Set<EditedCellKey>>>;
};

export const ManualTabContext = createContext<Props>({
  selectedRows: [],
  setSelectedRows: () => {},
  vacationBalances: [],
  setVacationBalances: () => {},
  editedCellKeys: new Set(),
  setEditedCellKeys: () => {},
});

export const ManualTabContextProvider: FC<{
  children?: ReactNode;
}> = ({ children }) => {
  const [selectedRows, setSelectedRows] = useState<Props["selectedRows"]>([]);
  const [vacationBalances, setVacationBalances] = useState<Props["vacationBalances"]>([]);
  const [editedCellKeys, setEditedCellKeys] = useState<Set<EditedCellKey>>(new Set());

  return (
    <ManualTabContext.Provider value={{ selectedRows, setSelectedRows, vacationBalances, setVacationBalances, editedCellKeys, setEditedCellKeys }}>
      {children}
    </ManualTabContext.Provider>
  );
};
